<template>
  <p
    :class="[
      'resend-verification-code-form',
      {
        disabled: state.$busy
      }
    ]"
    @click="onSubmit"
  >
    {{ state.$busy ? 'Resending...' : 'Resend' }}
  </p>
</template>
<script>
/**
 * ==================================================================================
 * Resend verification code form
 * ==================================================================================
 **/

import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'

export default {
  props: {
    form: {
      type: Form
    },
    to: {
      type: String,
      required: true,
      validation: function(value) {
        return (
          ['email', 'phone', 'forgot', 'verify-email', 'verify-phone'].indexOf(
            value
          ) !== -1
        )
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    value() {
      switch (this.to) {
        case 'email':
        case 'forgot':
          return this.form.email
        case 'phone':
          return this.form.phone_number
        case 'verify-email':
          return this.user.email
        case 'verify-phone':
          return this.user.phone_number
        default:
          return this.form.email || this.user.email
      }
    },

    label() {
      switch (this.to) {
        case 'email':
        case 'forgot':
        case 'verify-email':
          return 'email'
        case 'phone':
        case 'verify-phone':
        default:
          return 'phone_number'
      }
    },

    submit() {
      switch (this.to) {
        case 'verify-email':
        case 'verify-phone':
          return this.verificationCodeRequest
        case 'email':
          return this.changeEmailRequest
        case 'forgot':
          return this.changePasswordRequest
        case 'phone':
          return this.changePhoneRequest
        default:
          return ''
      }
    }
  },
  data: function() {
    return {
      state: new Form()
    }
  },
  methods: {
    ...mapActions({
      requestVerification: 'auth/requestVerification',
      requestChangeEmail: 'auth/requestChangeEmail',
      requestChangePhone: 'auth/requestChangePhone',
      requestForgotPassword: 'auth/requestForgotPassword',
      addAlert: 'alert/addAlert'
    }),

    async onSubmit() {
      if (this.state.$busy) return
      this.state.$setLoading(true)
      this.addAlert({
        countdown: true,
        label: 'Resending verification code to ' + this.value + '...'
      })

      await this.submit()
        .then(() => {
          this.afterSubmit(
            false,
            true,
            'Verification code sent to ' + this.value
          )
        })
        .catch(error => {
          this.state.$handleError(error)
          this.afterSubmit(false, false, this.state.$errorMessage)
        })
    },

    async verificationCodeRequest() {
      return this.requestVerification({
        via: this.label,
        to: this.value
      })
    },

    async changePasswordRequest() {
      return this.requestForgotPassword({
        email: this.form.email
      })
    },

    async changeEmailRequest() {
      return this.requestChangeEmail({
        email: this.form.email
      })
    },

    async changePhoneRequest() {
      return this.requestChangePhone({
        phone_number: this.form.phone_number
      })
    },

    afterSubmit(loading, state, message) {
      this.state.$setLoading(loading)
      this.addAlert({
        state: state,
        label: message
      })
    }
  }
}
</script>
<style scoped lang="scss">
.resend-verification-code-form {
  cursor: pointer;
}
.resend-verification-code-form.disabled {
  color: var(--input-border-color) !important;
}
</style>
